// extracted by mini-css-extract-plugin
export default {"wrapper":"B5Zpci","active":"L3207J","overlay":"vFTYlH","modal":"nFYct_","head":"fHO83u","closeButton":"huKAak"};